import { Configuration, LogLevel, RedirectRequest } from "@azure/msal-browser";
import { reportAuthEvent } from "./auth/auth-diagnostics";

const AUTHORITY =
  "https://login.microsoftonline.com/372ee9e0-9ce0-4033-a64a-c07073a91ecd";

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AUTH_CLIENT_ID,
    authority: AUTHORITY,
    redirectUri: import.meta.env.VITE_AUTH_REDIRECT_URI,
    postLogoutRedirectUri: null,
  },
  cache: {
    cacheLocation: "localStorage",
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        reportAuthEvent({
          type: "msal-log",
          decision: LogLevel[level],
          message,
        });
      },
    },
  },
};

// Silent requests must not carry domainHint: MSAL adds the account's sid and Entra rejects both together (AADSTS900051).
export const msalTokenRequest = {
  scopes: [`api://${import.meta.env.VITE_AUTH_CLIENT_ID}/serving-api`],
};

export const msalLoginRequest: RedirectRequest = {
  ...msalTokenRequest,
  domainHint: "abb.com",
};
